<template>
  <div class="d-inline-block">
    <base-text
      class="silka-title"
      light
      inline
    >
      Sent to:
    </base-text>
    <span
      v-for="(group, index) in item.segments.groups"
      :key="`segment_${index}`"
      class="clickable"
      @click="$emit('outreach-activity', group.pk)"
    >
      <base-text
        underline
        inline
        medium
      > {{ group.name }} ({{ group.count }})</base-text>
      {{ item.segments.groups.length > 1 && index < item.segments.groups.length -1 ? ',&nbsp;' : '' }}
    </span>
    <span>
      {{ (item.segments.customers > 0 || isNaN(item.segments.customers))
        && item.segments.groups.length > 0 ? ' , ' : '' }}
    </span>
    <base-text
      v-if="!isNaN(item.segments.customers) && item.segments.customers > 0"
      underline
      inline
      medium
      class="clickable"
      @click="$emit('outreach-activity', 0)"
    >
      {{ item.segments.customers }} Client{{ item.segments.customers.length != 1 ? 's' : '' }}
    </base-text>
    <!--
      If we have just one customer we are receiving an String
      This string could be an empty string, so we need to check for that
      if is not empty, we show the name, if it is empty we show the generic text.
      @see https://helloseer.slack.com/archives/C015UMFDKRS/p1637779483001100
     -->
    <base-text
      v-else-if="typeof(item.segments.customers) === 'string'"
      inline
      medium
      class="shared-to-client"
      @click="$emit('outreach-activity', 0)"
    >
      {{ item.segments.customers.trim() ? item.segments.customers : $t('clients.singleClient') }}
    </base-text>

    <!-- Shared to one client -->
    <!-- <base-text
      v-if="item.shared_to !== null"
      underline
      inline
      medium
      class="shared-to-client"
      @click="$emit('goToClientDetail', item.shared_to.pk)"
    >
      {{ item.shared_to.first_name }} {{ item.shared_to.last_name }}
    </base-text> -->
  </div>
</template>

<script>
export default {
  name: 'SentSummaryTo',
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
.shared-to-client {
  color: #1B1B1B;
  cursor: pointer;
}
.silka-title{
  font-family: 'SilkaLight';
  font-size: 14px;
  color: #767676;
}
</style>
